import clsx from 'clsx';
import React from 'react';

type ImageLabelProps = {
  className: React.ReactNode;
  children: React.ReactNode;
  size?: 'small' | 'big';
};

const ImageLabel = ({ className, children, size = 'big' }: ImageLabelProps) => (
  <div
    className={clsx(
      className,
      "absolute right-0 top-0 bg-pro-gold font-suisse-intl-mono leading-none text-white before:absolute before:left-[-30%] before:top-0 before:z-[-1] before:h-full before:w-full before:skew-x-30 before:bg-inherit before:content-['']",
      {
        'py-6 pl-4 pr-10 text-[16px]': size === 'small',
        'py-10 pl-12 pr-24 text-[22px]': size === 'big',
      }
    )}
  >
    {children}
  </div>
);

export default ImageLabel;
